import CityPageTemplate from "../city-template/CityPageTemplate";
import { youngstownConfig } from "./data";

export default function YoungstownPage() {
  return <CityPageTemplate config={youngstownConfig} />;
}